import { useSelector } from 'react-redux';

import { getIsMenuOpen } from '../../state/ui/general';
import { getLanguage } from '../../state/login';

export const useIsMenuOpen = () => useSelector(getIsMenuOpen);
export const useLanguage = () => useSelector(getLanguage);
